export const zonasRojas = [
  "Boca del Rio", "Cordoba", "Orizaba", "Coatzacoalcos", "Minatitlan",
  "Xalapa", "Xalapa Enriquez", "Zapoapan", "Choapas", "Tuxpan",
  "Tuxpam de Rodriguez Cano", "Magueyes", "Zonolica", "Zongolica", "Alvarado",
  "Tierra Blanca", "Martinez de la Torre", "Tezonapa", "Paso de Macho", "Paso del Macho",
  "Patrona", "Guadalupe", "San Andres Tuxtla", "Atoyac", "Matatenatito", "Mata Tenatito",
  "Autopista Cordoba Mexico", "Maltrata", "Ciudad Mendoza", "Cdad. Mendoza",
  "Camerino Z. Mendoza", "Chocaman", "Autopista Cosamaloapan La Tinaja", "Colonia",
  "Isla Pajaritos", "Isla de Pajaritos", "Carretera Paraje Soledad de Doblado",
  "Papaloapan", "Lerdo de Tejada", "Talladero", "Carretera El Amante Tierra Blanca",
  "Carretera El Amate Tierra Blanca", "Tres Valles", "Rancho Grande", "Ciudad Aleman",
  "Cd Aleman", "Yaguas", "Autopista Nogales Caseta de la Esperanza", "Cuesta Blanca",
  "Bellavista", "Puerta cananada", "Puerta Canada", "San Jose Ixtapa",
  "Tinaja", "Moralito", "Negritos", "Cerro Alto",
  "Huatusco Soledad de Doblado", "Represa", "Puentecilla", "Pueblito de Matlaluca",
  "Perla", "Tequila", "Campo Grande",
];

const normalizar = (valor = "") => String(valor)
  .normalize("NFD").replace(/[\u0300-\u036f]/g, "")
  .toLowerCase().replace(/[.]/g, "").replace(/[-–]/g, " ")
  .replace(/\s+/g, " ").trim();

export const esZonaRoja = (asistencia = {}) => {
  const estado = normalizar(asistencia.estadoOrigen);
  const municipio = normalizar(asistencia.municipioOrigen);
  return (
    estado === "veracruz" &&
    zonasRojas.some((nombre) => municipio.includes(normalizar(nombre)))
  );
};
